import React from 'react';
import { connect } from 'react-redux';

import "./Overlay.css";

const Overlay = ({ isUserHost }) => {
    return (
        <div className="overlay_container">
            <div className="overlay_paragraph">
                {!isUserHost && (<h1>Carregando...</h1>)}
            </div>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(Overlay);